import React from 'react';

import EssentialIcon from '../../../../../common/icons/EssentialIcon';

export default {
  title: '',
  dataIndex: 'status',
  width: '40px',
  render: text => <EssentialIcon type={text} style={{ fontSize: '1.1rem', color: '#51c7bf', fontWeight: 'bold' }} />
};
